import { render } from "./ContactDetailsPanel.vue?vue&type=template&id=00a0354e&scoped=true"
import script from "./ContactDetailsPanel.vue?vue&type=script&lang=js"
export * from "./ContactDetailsPanel.vue?vue&type=script&lang=js"

import "./ContactDetailsPanel.vue?vue&type=style&index=0&id=00a0354e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a0354e"]])

export default __exports__